import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import Cookies from "js-cookie";

const BrandCard = ({ img, id , brand }) => {
  const brandName = Cookies.get("i18next") === "en" ? brand?.nameEn : brand?.nameAr;

  return (
    <Link to={`/products/brand/${id}?page=1`} title={brandName} style={{ textDecoration: 'none', display: 'block' }}>
      <div className="noon-category-card">
        <Fade>
          <div className="noon-category-img-box">
            <img
              className="noon-category-img"
              src={img}
              alt={brandName}
              loading="lazy"
            />
          </div>
          <div className="noon-category-text" style={{ fontSize: '13px', fontWeight: 'bold' }}>{brandName}</div>
        </Fade>
      </div>
    </Link>
  );
};

export default BrandCard;
